import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { cardsClient } from "@core/clients";
import { Card, DeletedCard } from "@core/types";
import { queryClient } from "../../config/query-client";

const useDeleteCardMutation = (options?: UseMutationOptions<DeletedCard, any, { id: string }>) =>
  useMutation(
    ["deleteCard"],
    async ({ id }) => {
      const data = await cardsClient?.deleteCard({ id });
      return data;
    },
    {
      onSuccess(data, variables, context) {
        queryClient.setQueryData<Card[]>(["cards"], (oldData) => {
          const updatedData = oldData?.filter((card) => card.id !== variables.id);
          return updatedData;
        });
        options?.onSuccess?.(data, variables, context);
      },
      ...options,
    }
  );

export default useDeleteCardMutation;
